<form (ngSubmit)="onSubmit()" class="form" [formGroup]="filtersForm" [ngClass]="ListingCategory[currentShownListingType]">
  <br/>
  <app-search-bar></app-search-bar>
  <p style="clear:both;" translate="filters.search-text"></p>
  <div style="clear:both;">
    <label translate="filters.property-types"></label>
    <app-switch [allowUncheck]="false" [checked]="showAllPropTypes" label="{{ 'filters.all' | translate }}" (checkedChange)="clearListingTypes(true)"
    style="margin-top: 10px;" inputId="input-switch-all"></app-switch>
    <app-switch *ngIf="currentShownListingType === ListingCategory.RESIDENTIAL" [allowUncheck]="true" [checked]="onlyRentals" label="{{ 'filters.rentals-only' | translate }}"  inputId="input-switch-rentals"
      (checkedChange)="toggleRentals($event)"></app-switch>
    <app-switch *ngIf="currentShownListingType !== ListingCategory.COMMERCIAL" [allowUncheck]="true" [checked]="onlyOpenHouses" label="{{ 'filters.open-houses-only' | translate }}"  inputId="input-switch-open-houses"
      (checkedChange)="toggleOpenHouses($event)"></app-switch>
    <hr/>
    <fieldset [formGroup]="listingTypesFg">
      <app-checkbox [text]="'filters.listing-type.house' | translate"
      [formControl]="listingTypesFg.get('house')" [parentFormGroup]="listingTypesFg"></app-checkbox>
      <app-checkbox [text]="'filters.listing-type.condo' | translate"
      [formControl]="listingTypesFg.get('condo')" [parentFormGroup]="listingTypesFg"></app-checkbox>
      <app-checkbox [text]="'filters.listing-type.townhouse' | translate"
      [formControl]="listingTypesFg.get('townhouse')" [parentFormGroup]="listingTypesFg"></app-checkbox>
      <ng-container *ngIf="currentShownListingType === ListingCategory.RESIDENTIAL">
        <app-checkbox [text]="'filters.listing-type.recreational' | translate"
        [formControl]="listingTypesFg.get('recreational')" [parentFormGroup]="listingTypesFg"></app-checkbox>
        <!-- These filters are hidden by default in mobile. -->
        <app-checkbox [text]="'filters.listing-type.farm' | translate"
        [formControl]="listingTypesFg.get('farm')" [parentFormGroup]="listingTypesFg" *ngIf="showingAllTypes || listingTypesFg.get('farm').value"></app-checkbox>
        <app-checkbox [text]="'filters.listing-type.land' | translate"
        [formControl]="listingTypesFg.get('land')" [parentFormGroup]="listingTypesFg" *ngIf="showingAllTypes || listingTypesFg.get('land').value"></app-checkbox>
        <app-checkbox [text]="'filters.listing-type.mobile-home' | translate"
        [formControl]="listingTypesFg.get('mobileHome')" [parentFormGroup]="listingTypesFg" *ngIf="showingAllTypes || listingTypesFg.get('mobileHome').value"></app-checkbox>
        <a *ngIf="!showingAllTypes" (click)="showingAllTypes = true" class="see-more-or-less">
          {{ 'filters.listing-type.show-more' | translate }}
          <i class="material-icons v-align">keyboard_arrow_down</i>
        </a>
        <a *ngIf="showingAllTypes" (click)="showingAllTypes = false" class="see-more-or-less">
          {{ 'filters.listing-type.show-fewer' | translate }}
          <i class="material-icons v-align">keyboard_arrow_up</i>
        </a>
      </ng-container>
    </fieldset>
  </div>
  <hr/>
  <div style="padding: 5% 0;">
    <ng-container *ifPlatform="'browser'">
      <app-min-max-slider [values]="onlyRentals ? rentalValues : filteredPriceValues" [label]="('filters.price-range' | translate)"
      [parentFormGroup]="filtersForm" [formControl]="filtersForm.get('price')"
      [toMagnitudes]="toMagnitudes(true)" anyValueText="Any Price"></app-min-max-slider>
    </ng-container>
  </div>
  <hr/>
  <app-select [label]="('filters.beds' | translate)" [options]="bedOptions" [compareWith]="compareWithHasMinMax" placeholder="Any"
  [formControl]="filtersForm.get('beds')" [parentFormGroup]="filtersForm"></app-select>
  <hr/>
  <app-select [label]="('filters.baths' | translate)" [options]="bathOptions" [compareWith]="compareWithHasMinMax" placeholder="Any"
  [formControl]="filtersForm.get('baths')" [parentFormGroup]="filtersForm"></app-select>
  <hr/>
  <app-select id="desktopFilters-select-updatedSince" label="Updated Since" [options]="updatedSinceOptions" class="updatedSince-select"
              [formControl]="filtersForm.get('updatedSince')" [parentFormGroup]="filtersForm"></app-select>
  <hr/>
  <div style="padding: 5% 0%;">
    <ng-container *ifPlatform="'browser'">
      <app-min-max-slider [values]="sizeValues" [label]="('filters.square-feet' | translate)"
      [parentFormGroup]="filtersForm" [formControl]="filtersForm.get('size')"
      anyValueText="Any Size" unit="sqft"></app-min-max-slider>
    </ng-container>
  </div>
  <div class="text-center">
    <button class="btn btn-fake btn-bold" (click)="onReset()">
      <svg height="15" width="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-label="Reset all">
        <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(-116 -923)" fill="none" fill-rule="evenodd">
            <g transform="translate(116.76 923.66)" fill="#004E9B">
              <path d="m5.3577 5.5705c0-0.31292-0.25769-0.56568-0.57692-0.56568l-2.5577 0.007946c0.73846-2.2438 2.8962-3.8054 5.3077-3.8129h0.019231c2.6923 0 5.0077 1.8855 5.5038 4.4895 0.05 0.27281 0.29231 0.46351 0.56538 0.46351 0.034615 0 0.073077-0.0034054 0.10769-0.0098378 0.31154-0.057892 0.51923-0.35416 0.46154-0.66254-0.6-3.1413-3.3885-5.4157-6.6385-5.4157h-0.023077c-2.6692 0.0083243-5.0846 1.5998-6.15 3.9571l-0.0076923-2.128c0-0.31254-0.26154-0.56568-0.57692-0.56568h-0.0038462c-0.31538 0.0011351-0.57308 0.25616-0.57308 0.56946l0.011538 3.6892c0 0.15059 0.061538 0.29476 0.16923 0.4007s0.25385 0.16497 0.40769 0.16497l3.9808-0.012486c0.31923-0.0011351 0.57692-0.25616 0.57308-0.56946"/>
              <path d="m14.858 8.1223c-0.0038461-0.31254-0.26154-0.56568-0.57692-0.56568h-0.0038461l-3.9769 0.012486c-0.31923 0.0011351-0.57692 0.25616-0.57692 0.56946 0.0038462 0.31292 0.26154 0.56568 0.57692 0.56568h0.0038462l2.5962-0.007946c-0.70769 2.3002-2.8692 3.8943-5.3346 3.9022h-0.015385c-2.4231 0-4.8769-1.8756-5.3654-4.1024-0.069231-0.30686-0.37692-0.50059-0.68462-0.43551-0.31154 0.066216-0.51154 0.36816-0.44231 0.67427 0.60385 2.7599 3.5154 4.9988 6.4923 4.9988h0.019231c2.6846-0.0087027 5.0692-1.5722 6.1385-3.9143l0.0076923 1.9959c0 0.31254 0.25769 0.56568 0.57692 0.56568 0.31923-0.0011351 0.57692-0.25616 0.57692-0.56946l-0.011538-3.6892"/>
            </g>
          </g>
        </svg>
      </svg>
      {{ 'filters.reset' | translate }}
    </button>
  </div>
  <p class="text-center">{{ 'filters.n-results' | translate: { n: listingsAvailable } }}</p>
  <button type="submit"
          class="btn btn-bold btn-full-sized"
          [class.btn-color]="ListingCategory.RESIDENTIAL==currentShownListingType"
          >
    <span class="full-width" translate="filters.apply"></span>
  </button>
</form>
